import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ListItem, ListItemIcon, ListItemText, Typography } from '@mui/material';
import { inject, observer } from 'mobx-react';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useLocation, useMatch, useNavigate } from 'react-router-dom';
import { AppPageRoutes } from 'src/services/api/models';
import QueryParams from 'src/services/QueryParamsService';
import RoleBaseAccess from 'src/services/RoleBaseAccess';
import Store from 'src/stores/RootStore';
import UserStore from 'src/stores/UserStore';
import { getMenuListRoutes, GroupRoutes, ListRoutes } from 'src/utils/getMenuListRoutes';

interface MenuListProps {
    store?: typeof Store.Type;
    user?: typeof UserStore.Type;
}

const MenuListItems = inject(
    'store',
    'user',
)(
    observer(({ store, user }: MenuListProps) => {
        const navigate = useNavigate();

        const groupedListOfRoutes = getMenuListRoutes({ useNewReturnRequest: user?.useNewReturnRequest });

        // @TODO: add type to path and children
        function Match({ path, children }: { path: any; children: any }) {
            let match = useMatch(path);
            let location = useLocation();
            return children({ match, location, navigate });
        }

        return (
            <>
                {groupedListOfRoutes.map((group: GroupRoutes) => (
                    <React.Fragment key={group.name}>
                        {group.name !== 'dashboard' && (
                            <Typography sx={{ opacity: 0.5, paddingLeft: '12px' }}>
                                <FormattedMessage id={group.name} />
                            </Typography>
                        )}
                        {group.routes.map((item: ListRoutes) => {
                            return RoleBaseAccess.isRouteAllowed(item.route as AppPageRoutes) ? (
                                <Match key={item.route} path={`${item.route}/*`}>
                                    {({ match }: { match: any }) => (
                                        <ListItem
                                            onClick={() => {
                                                if (item.route === AppPageRoutes.SPARE_PARTS) {
                                                    store!.spareParts.searchResult.clearResult();
                                                    QueryParams.resetQueryParams();
                                                }
                                                if (item.route === AppPageRoutes.NEW_RETURN_REQUEST) {
                                                    store!.spareParts.searchResult.clearResult();
                                                    QueryParams.resetQueryParams();
                                                }
                                                if (item.hasOwnProperty('target')) {
                                                    window.open(item.route, item.target);
                                                } else {
                                                    navigate(item.route);
                                                }
                                            }}
                                            key={item.text}
                                            selected={!!match}
                                            data-testid={item.testId}
                                            button
                                        >
                                            <ListItemIcon>
                                                {item.text === 'menu.dashboard' ? (
                                                    item.icon
                                                ) : (
                                                    <FontAwesomeIcon icon={item.icon} size="xl" />
                                                )}
                                            </ListItemIcon>
                                            <ListItemText>
                                                <FormattedMessage id={item.text} />
                                            </ListItemText>
                                        </ListItem>
                                    )}
                                </Match>
                            ) : null;
                        })}
                    </React.Fragment>
                ))}
            </>
        );
    }),
);

export default MenuListItems;
